import { isEmailValid } from '../../input';

export const agencyValidationConfig = {
  firstname: {
    required: true,
    pattern: /^[a-zA-Z][a-zA-Z\s\-']*$/,
    customErrorMessage: { pattern: 'Invalid first name.' }
  },
  lastname: {
    required: true,
    pattern: /^[a-zA-Z][a-zA-Z\s\-']*$/,
    customErrorMessage: { pattern: 'Invalid last name.' }
  },
  email: {
    required: true,
    customValidator: (value) => {
      const result = { isValid: false, message: '' };
      if (!isEmailValid(value)) {
        result.message = 'Invalid email address.';
      } else result.isValid = true;
      return result;
    }
  },
  street: {
    required: true,
    minLength: 3
  },
  zip: {
    required: true,
    pattern: /^[a-zA-Z0-9\s-]{3,10}$/,
    customErrorMessage: { pattern: 'Invalid postal/zip code.' }
  },
  phone_number: {
    required: true,
    pattern: /^\+?\d{10,14}$/,
    customErrorMessage: { pattern: 'Invalid phone number.' }
  },
  bvn: {
    required: true,
    pattern: /^\d{11}$/,
    minLength: 11,
    maxLength: 11
  },
  nin: {
    required: true,
    pattern: /^\d{11}$/,
    minLength: 11,
    maxLength: 11
  },
  business_name: {
    required: true,
    minLength: 2
  },
  cac_number: {
    required: true,
    pattern: /^[A-Za-z0-9-]{6,}$/,
    customErrorMessage: { pattern: 'Invalid CAC number.' }
  },
  operator_email: {
    required: true,
    customValidator: (value) => {
      const result = { isValid: false, message: '' };
      if (!isEmailValid(value)) {
        result.message = 'Invalid email address.';
      } else result.isValid = true;
      return result;
    }
  }
};
